import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SpinnerLoading from 'components/Loading/SpinnerLoading';
import { useForm } from "react-hook-form";
import { Button } from "@chakra-ui/react";
import _ from "lodash";
import * as actions from "redux/actions";
import axios from 'axios';

export default function EditPath() {
    const { register, handleSubmit, errors } = useForm();
    const { id, pathId } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const path = useSelector((state) => state.path);
    const [pathData, setPathData] = useState();

    useEffect(() => {
        dispatch(actions.pathGet(pathId)).then(() => {
            setIsLoading(true);
        })
        return () => { }
    }, [])

    useEffect(() => {
        setPathData(path);
        return () => { }
    }, [path])

    const onSubmit = (data) => {

        if (data?.origin_expected && data?.destination_expected) {
            const payload = {
                origins: [data?.origin_expected],
                destinations: [data?.destination_expected],
            }
            //ค้นหาเส้นทาง
            axios
                .post(
                    process.env.REACT_APP_API_URL + '/other/find-distance',
                    payload
                )
                .then((res) => {
                    if (res.data.status === 'OK') {
                        data.origin_actual = res.data.origin_addresses[0];
                        data.destination_actual = res.data.destination_addresses[0];
                        data.duration = res.data.rows[0].elements[0].duration.text;
                        data.distance = res.data.rows[0].elements[0].distance.text;

                        const confirm = window.confirm(
                            'ยืนยันการเลือกตำแหน่งจาก ' +
                            data.origin_actual +
                            ' ไปยัง ' +
                            data.destination_actual
                        );
                        if (confirm) {
                            dispatch(actions.pathPut(pathId, data)).then(() => {
                                window.location.reload();
                            })
                        }
                    }
                })
        }
    }

    return isLoading ? (
        <div>
            <div>
                <h2 className="text-gray-800 text-xl font-semibold">
                    แก้ไขเส้นทาง {pathData?.origin_expected} - {pathData?.destination_expected}
                </h2>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mt-4 justify-start">
                    <Button
                        onClick={() => history.goBack()}
                        variant="outline"
                    >กลับ
                    </Button>
                </div>
                <div className="p-4">
                    <div className="flex content-center items-center justify-center h-full">
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="relative w-full mb-3 flex flex-wrap">
                                <div className="flex flex-row w-full">
                                    <div className="relative w-full mb-3">
                                        <label className="block uppercase text-gray-700 text-xs font-bold mb-2">
                                            ลำดับ
                                        </label>
                                        <input
                                            name="index"
                                            ref={register}
                                            defaultValue={pathData?.index}
                                            placeholder="ลำดับ"
                                            className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-xs shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                                        ></input>
                                    </div>
                                    <div className="relative w-full mb-3">
                                        <label className="block uppercase text-gray-700 text-xs font-bold mb-2">
                                            ราคาน้ำมัน
                                        </label>
                                        <input
                                            name="gasoline"
                                            ref={register}
                                            defaultValue={pathData?.gasoline}
                                            placeholder="น้ำมัน/km"
                                            className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-xs shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                                        ></input>
                                    </div>
                                </div>
                                <div className="relative w-full mb-3">
                                    <label
                                        className="block uppercase text-gray-700 text-xs font-bold mb-2"
                                        htmlFor="grid-password"
                                    >
                                        เริ่มต้น
                                        <input
                                            name="origin_expected"
                                            ref={register}
                                            defaultValue={pathData?.origin_expected}
                                            placeholder="เริ่มต้น"
                                            className="px-3 py-3 mt-2 placeholder-gray-400 text-gray-700 bg-white rounded text-xs shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                                        ></input>
                                    </label>
                                </div>
                                <div className="relative w-full mb-3">
                                    <label
                                        className="block uppercase text-gray-700 text-xs font-bold mb-2"
                                        htmlFor="grid-password"
                                    >
                                        ปลายทาง
                                        <input
                                            name="destination_expected"
                                            ref={register}
                                            defaultValue={pathData?.destination_expected}
                                            placeholder="ปลายทาง"
                                            className="px-3 py-3 mt-2 placeholder-gray-400 text-gray-700 bg-white rounded text-xs shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                                        ></input>
                                    </label>
                                </div>
                            </div>
                            <div className="text-center mt-6 ">
                                <Button
                                    isFullWidth
                                    colorScheme="blue"
                                    type="submit"
                                >
                                    บันทึก
                                </Button>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </div>
    ) : (
        <SpinnerLoading />
    )
}